import SpriteAnimation from "./SpriteAnimation";
import SpriteAnimationManager from "./SpriteAnimationManager";
import AnimationRowSpritesheet from "./AnimationRowSpritesheet";
import { CharacterAction } from "../character/CharacterAction";

export default class CharacterSpritesheet extends AnimationRowSpritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     * @param {SpriteAnimationManager} spriteAnimationManager
     */
    constructor(fileName, spriteSize, spriteAnimationManager) {
        super(fileName, spriteSize);

        /**
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = spriteAnimationManager;

        /**
         * @private
         * @type {SpriteAnimation}
         */
        this.defaultAnimation = null;

        /**
         * The mapping of sprite animation by name.
         * @private
         * @type {{}}
         */
        this.spriteAnimationMap = {};

        // Tell the superclass to start loading the image.
        this.loadImage();
    }

    /**
     * @param {string} characterAction See CharacterAction.
     * @returns {SpriteAnimation}
     */
    getSpriteAnimation(characterAction) {
        const spriteAnimation = this.spriteAnimationMap[characterAction];
        return spriteAnimation ? spriteAnimation : this.defaultAnimation;
    }

    /**
     * @override
     * @param {number} spriteSize
     * @returns {number}
     */
    calculateSpriteStep(spriteSize) {        
        return spriteSize + 1; // +1 because there is a 1px gap between sprites.
    }
    
    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {
        // Each row contains sprites for a particular character action.

        let row = 0;

        this.defaultAnimation = this.populateSpriteAnimation(row++, 1, false, true);

        this.spriteAnimationManager[CharacterAction.STAND] = this.defaultAnimation;
        this.spriteAnimationManager[CharacterAction.FALL] = this.defaultAnimation;
        this.spriteAnimationManager[CharacterAction.MINE] = this.defaultAnimation;
        //////////this.spriteAnimationManager[CharacterAction.ATTACK] = this.defaultAnimation;

        this.spriteAnimationManager[CharacterAction.JUMP] = this.populateSpriteAnimation(row++, 1, false, true);
        this.spriteAnimationManager[CharacterAction.WALK] = this.populateSpriteAnimation(row++, 2, false, true);
    
        /////////////////////////////////////
        // Mark the spritesheet as loaded.
        /////////////////////////////////////

        this.loaded = true;
    }

    /**
     * @private
     * @param {number} row 
     * @param {number} numSprites 
     * @param {boolean} fastAnimation
     * @param {boolean} loopingAnimation
     * @returns {SpriteAnimation}
     */
    populateSpriteAnimation(row, numSprites, fastAnimation, loopingAnimation) {
        const sprites = this.parseRow(row, numSprites);
        return new SpriteAnimation(sprites, this.spriteAnimationManager, fastAnimation, loopingAnimation);
    }

}